export default {
  props: {
    inertProp: Boolean,
  },
  data() {
    return {
      menu: false,
    };
  },
  watch: {
    menu(val) {
      this.$emit("menuEvent", val);
    },
  },
};
